export default "__VITE_ASSET__78da722d__"